import { useLocation } from "react-router-dom";
import MyLoadDetail from "./MyLoad";
import SearchLoadDetail from "./SearchLoad";

export default function LoadDetail() {
  const { state } = useLocation();
  const isMyLoad = state?.my_load;
  return isMyLoad ? <MyLoadDetail /> : <SearchLoadDetail />;
}
